import { Oval } from 'react-loader-spinner';

type TProps = {
  size: number;
};

export const Loader = ({ size = 20 }: TProps) => {
  return <Oval color="var(--color-surface)" height={size} width={size} />;
};
